var map = {
	"./icon_location_0.png": "c77a",
	"./icon_location_1.png": "ec42",
	"./icon_location_2.png": "ec55",
	"./icon_location_arrows.png": "841e",
	"./icon_location_white.png": "cac5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e91b";